import { containsVideoCallShareUrlReference } from "~/utils/videoCalls/invitation";

const VIDEO_CALL_TELEMETRY_PATHS = ["/api/video-calls/", "/ws/video-calls/"];

export const isVideoCallTelemetryUrl = (url: string) =>
  VIDEO_CALL_TELEMETRY_PATHS.some((path) => url.includes(path)) ||
  containsVideoCallShareUrlReference(url);

export const containsVideoCallTelemetryReference = (
  value: unknown,
  seen = new WeakSet<object>(),
): boolean => {
  if (typeof value === "string") {
    return isVideoCallTelemetryUrl(value);
  }
  if (!value || typeof value !== "object" || seen.has(value)) {
    return false;
  }

  seen.add(value);
  if (Array.isArray(value)) {
    return value.some((item) =>
      containsVideoCallTelemetryReference(item, seen),
    );
  }

  return Object.entries(value).some(
    ([key, item]) =>
      isVideoCallTelemetryUrl(key) ||
      containsVideoCallTelemetryReference(item, seen),
  );
};
